import React, { useState, useEffect, useRef } from "react";

import Header from "../OrderManagement/Header";
import ItemListPage from "../Item/List";
import PopupMessage from "../../ui/PopupMessage";

import { headers } from "../../utils/utils";

import { CircularProgress } from "@mui/material";

import {
  Box,
  Grid,
  Button,
  Typography,
  IconButton,
  Card,
  CardContent,
  CardHeader,
  Tabs,
  Tab,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";

import {
  Inbox as InboxIcon,
  Edit as EditIcon,
  Save as SaveIcon,
  Delete as DeleteIcon,
  Category as CategoryIcon,
  Description as DescriptionIcon,
  QrCode as CodeIcon,
  ViewList as ViewListIcon,
  Label as LabelIcon,
  Info as InfoIcon,
} from "@mui/icons-material";


const ShowPage = ({ id }) => {
  const [itemData, setItemData] = useState({
    id: "",
    name: "",
    description: "",
    code: "",
    hsnCode: "",
    category: "",
    salePrice: "",
    purchasePrice: "",
    onlineOrder: false,
    stockTracking: false,
    stockAlert: false,
    batchTracked: false,
    minStock: "",
    reorder: "",
  });

  useEffect(() => {
    fetchItemShow();
  }, []);
  const debounceTimeoutRef = useRef(null);
  const [images, setImages] = useState([
    "/path/to/image1.jpg",
    "/path/to/image2.jpg",
  ]);
  const [tabValue, setTabValue] = useState(0);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editMode, setEditMode] = useState({
    name: false,
    description: false,
    code: false,
    hsnCode: false,
    category: false,
    salePrice: false,
    purchasePrice: false,
  });

  const [messageOpen, setMessageOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("success");

  const [loading, setLoading] = useState(false);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };


    const handleEditToggle = (field) => {
        setEditMode((prev) => ({
          ...prev,
          [field]: !prev[field], // Toggle edit mode for the specific field
        }));
      };

  const fetchItemShow = async (field, value) => {
    const response = await fetch(
      process.env.REACT_APP_ITEM + "/item/show/" + id,
      {
        method: "GET",
        headers: headers(),
      },
    );

    if (response.ok) {
      const data = await response.json();
      setItemData(data);
    } else {
      console.error("Failed to fetch item details. Status:", response.status);
    }
  };
  const handleChange = (field, value) => {
    console.log("Beoft ItemDa ta", itemData);
    setItemData((prev) => ({ ...prev, [field]: value }));

        console.log("affter ItemDa ta",itemData)

       
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }
    };

    const handleCustomChange = (key, value) => {
        setItemData((prev) => ({
            ...prev,
            customFields: {
                ...prev.customFields,
                [key]: value
            }
        }));
    };

    
    const customFieldIcons = {
        shortName: <InfoIcon />,
    };

    const itemUpdate = async (field) => {
        const response = await fetch(process.env.REACT_APP_ITEM + '/item/update/' + id, {
            method: "PUT",
            body: JSON.stringify(itemData), 
            headers: headers(),
        });

        if (response.ok) {
            setMessage("Item updated successfully")
            setMessageType("success")
            handleEditToggle(field)
        }
    }



  const handleDelete = async () => {
    setLoading(true);
    setDialogOpen(true);
  };

  const handleDialogClose = () => (setDialogOpen(false), setLoading(false));
  const handleConfirmDelete = async () => {
    try {
      setMessageOpen(true);
      const response = await fetch(
        process.env.REACT_APP_ITEM + `/item/delete/${id}`,
        {
          method: "DELETE",
          headers: headers(),
        },
      );

      if (response.ok) {
        setMessage("Item deleted successfully");
        setMessageType("error");

        setDialogOpen(false);

        return <ItemListPage />;
      } else {
        console.error("Failed to delete item");
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Box
        p={3}
        sx={{
          margin: "20px",
          boxShadow: 3,
          borderRadius: 2,
          background: "white",
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={3}
        >
          <Typography variant="h4" display="flex" alignItems="center" gap={2}>
            <InboxIcon /> Item Details
          </Typography>
        </Box>

                <Tabs value={tabValue} onChange={handleTabChange} aria-label="Item Details Tabs" centered>
                    <Tab label="Basic Info" />
                    <Tab label="Pricing" />
                    <Tab label="Stock Info" />
                    <Tab label="Images" />
                </Tabs>

               
                {tabValue === 0 && (
                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12}>
                            <Card>
                                <CardHeader title="Basic Information" />
                                <CardContent>
                                    {[
        { field: "name", label: "Name", icon: <LabelIcon /> },
        { field: "description", label: "Description", icon: <DescriptionIcon /> },
        { field: "code", label: "Code", icon: <CodeIcon /> },
        { field: "hsnCode", label: "HSN Code", icon: <ViewListIcon /> },
        { field: "category", label: "Category", icon: <CategoryIcon /> },
      ].map(({ field, label, icon }) => (
        <Box key={field} sx={{ display: "flex", alignItems: "center", gap: "10px", mb: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", minWidth: "150px" }}>
            {icon}
            <Typography variant="body1" sx={{ fontWeight: 600, ml: 1 }}>
              {label}:
            </Typography>
          </Box>
          {editMode[field] ? (
            <TextField
              variant="outlined"
              size="small"
              value={itemData[field] || ""}
              onChange={(e) => handleChange(field, e.target.value)}
              onBlur={() => itemUpdate(field)}
              autoFocus
            />
          ) : (
            <Typography
              onClick={() => handleEditToggle(field)}
              sx={{ cursor: "pointer", textDecoration: "underline" }}
            >
              {itemData[field] || "N/A"}
            </Typography>
          )}
          <IconButton onClick={() => handleEditToggle(field)}>
          {editMode[field] ? "" : <EditIcon />}
          </IconButton>
        </Box>
      ))}

{itemData.customFields && Object.keys(itemData.customFields).length > 0 ? (
                                        Object.entries(itemData.customFields).map(([key, value]) => (
                                            <Box key={key} sx={{ display: "flex", alignItems: "center", gap: "10px", mb: 1 }}>
                                                <Box sx={{ display: "flex", alignItems: "center", minWidth: "150px" }}>
                                                    {customFieldIcons[key] || <InfoIcon />}
                                                    <Typography variant="body1" sx={{ fontWeight: 600, ml: 1 }}>
                                                        {key.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase())}:
                                                    </Typography>
                                                </Box>
                                                {editMode[key] ? (
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        value={value || ""}
                                                        onChange={(e) => handleCustomChange(key, e.target.value)}
                                                        onBlur={() =>itemUpdate(key) }
                                                        autoFocus
                                                    />
                                                ) : (
                                                    <Typography
                                                        onClick={() => handleEditToggle(key)}
                                                        sx={{ cursor: "pointer", textDecoration: "underline" }}
                                                    >
                                                        {value || "N/A"}
                                                    </Typography>
                                                )}
                                                <IconButton onClick={() => {
    if (editMode[key]) {
        itemUpdate(key); 
    }
    handleEditToggle(key);  
}}>
    {editMode[key] ? "" : <EditIcon />}
</IconButton>
                                            </Box>
                                        ))
                                    ) : (
                                       ""
                                    )}


                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                )}

                
                {tabValue === 1 && (
                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12}>
                            <Card>
                                <CardHeader title="Pricing" />
                                <CardContent>
                                    {["salePrice", "purchasePrice"].map((field) => (
                                        <Box key={field} sx={{ display: "flex", alignItems: "center", gap: "10px", mb: 1 }}>
                                            <Typography variant="body1" sx={{ fontWeight: 600, minWidth: "120px" }}>
                                                {field.charAt(0).toUpperCase() + field.slice(1).replace(/([A-Z])/g, " $1")}:
                                            </Typography>
                                            {editMode[field] ? (
                                                <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    value={itemData[field]}
                                                    onChange={(e) => handleChange(field, e.target.value)}
                                                    onBlur={() => itemUpdate(field)}
                                                    autoFocus
                                                />
                                            ) : (
                                                <Typography
                                                    onClick={() => handleEditToggle(field)}  // Click event to toggle text field
                                                    sx={{ cursor: "pointer", textDecoration: "underline" }}
                                                >
                                                    ${itemData[field]}
                                                </Typography>
                                            )}
                                            <IconButton onClick={() => handleEditToggle(field)}>
                                                {editMode[field] ? <SaveIcon /> : <EditIcon />}
                                            </IconButton>
                                        </Box>
                                    ))}
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                )}

               
                {tabValue === 2 && (
                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12}>
                            <Card>
                                <CardHeader title="Stock Information" />
                                <CardContent>
                                    <Typography>
                                        Stock Tracking:{" "}
                                        {itemData.stockTracking ? (
                                            <span style={{ color: "green" }}>Enabled</span>
                                        ) : (
                                            <span style={{ color: "red" }}>Disabled</span>
                                        )}
                                    </Typography>
                                    {itemData.stockTracking && (
                                        <>
                                            <Typography>Batch Tracking: {itemData.batchTracked ? "Yes" : "No"}</Typography>
                                            <Typography>Stock Alert: {itemData.stockAlert ? "Enabled" : "Disabled"}</Typography>
                                            <Typography>Minimum Stock: {itemData.minStock || "N/A"}</Typography>
                                            <Typography>Reorder Level: {itemData.reorder || "N/A"}</Typography>
                                        </>
                                    )}
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                )}

                
                {tabValue === 3 && (
                    <Grid container spacing={2} mt={2}>
                        {images.length > 0 ? (
                            images.map((img, index) => (
                                <Grid item xs={6} sm={4} md={3} key={index}>
                                    <Box
                                        component="img"
                                        sx={{
                                            width: "100%",
                                            height: "auto",
                                            borderRadius: "4px",
                                            boxShadow: 2,
                                        }}
                                        src={img}
                                        alt={`Image ${index + 1}`}
                                    />
                                </Grid>
                            ))
                        ) : (
                            <Typography>No Images Uploaded</Typography>
                        )}
                    </Grid>
                )}

                
                <Box mt={3}>

                    <Button
                        variant="outlined"
                        color="error"
                        onClick={handleDelete}
                        disabled={loading} 
                        startIcon={loading ? <CircularProgress size={20} /> : <DeleteIcon />} 
                        sx={{
                            fontWeight: 'bold',
                            borderRadius: '8px',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                backgroundColor: '#f44336',
                                color: 'white',
                                transform: 'scale(1.05)',
                            },
                            '&:disabled': {
                                backgroundColor: '#f44336',
                                opacity: 0.6,
                            },
                        }}
                    >
                        {loading ? 'Deleting...' : 'DELETE'}
                    </Button>


                </Box>
            </Box>

      {/* Delete Confirmation Dialog */}
      <Dialog open={dialogOpen} onClose={handleDialogClose}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this item?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="success">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <PopupMessage
        messageType={messageType}
        message={message}
        messageOpen={messageOpen}
      />
    </>
  );
};

export default ShowPage;
